import { CheckCircle } from 'lucide-react';

const COURSE = {
  id: '1',
  title: 'Seller Account Setup Course',
  instructor: 'Manikandan',
  rating: 4.9,
  students: 8450,
  duration: '12h 30m',
  level: 'Beginner',
  price: 'Free',
  category: 'E-Commerce',
  image: 'https://i.pinimg.com/1200x/de/c3/a6/dec3a6cb51913d7876702cb0bc56e14d.jpg',
  description: 'Learn how to register your Amazon, Flipkart & Meesho seller accounts without confusion or rejection. From documents to shipping settings — make your account ready to start selling.',
};

const enrollmentFeatures = [
  'Full lifetime access',
  'Access on mobile and TV',
  'Certificate of completion',
  'Lifetime support'
];

export default function CourseView() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10 mb-12">
      <div className="lg:col-span-2">
        <div className="relative rounded-xl sm:rounded-2xl overflow-hidden aspect-video group">
          <div className="bg-gradient-to-br from-amber-500 to-orange-500 w-full h-full">
            <img 
              src={COURSE?.image} 
              alt="Course Preview" 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>
      </div>
      
      <div className='flex items-center justify-center lg:justify-end'>
        <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-orange-100 flex flex-col justify-between">
          <div>
            <h3 className="text-xs sm:text-sm font-bold text-orange-900 uppercase tracking-widest mb-2">Enrollment</h3>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 mb-3 sm:mb-4">
              {COURSE.price}
            </div>
            <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-8">
              {enrollmentFeatures?.map((feature, index) => (
                <li key={index} className="flex items-center gap-2 text-xs sm:text-sm text-slate-600">
                  <CheckCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-orange-500" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}